<template>
  <div class="mt-4">
    <b-row>
      <b-col sm="12" md="8" lg="8" offset-lg="2" offset-md="2">
        <h2>Privacy Policy for Accessing Google APIs</h2>
        <p>
          iRidium Assistant uses
          <a href="https://developers.google.com/nest/device-access/api"
            >Smart Device Management API</a
          >
          to manage Google Nest devices.
        </p>
        <p>
          Learn more about how to configure it for management Google Nest
          devices, see
          <a href="https://dev.iridi.com/Nest/en">
            Interface to control Nest automation equipment
          </a>
        </p>
        <p>
          iRidium Assistant uses the "iRidium for Nest" application on the cloud platform
          Google. (You will see this name on the consent screen.) This
          integration governed by the general policies described here.
        </p>
        <p>
          Using Google API with iRidium Assistant is regulated the respective
          terms of service for each API's. See
          <a href="https://developers.google.com/terms">
            Google API Terms of Service
          </a>
        </p>

        <h2>Accessing user data</h2>
        <p>
          Access to Google resources is carried out only from the domain and
          subdomains
          <a href="https://iridi.com/"> iridi.com </a>
        </p>
        <p>
          IRidium applications using the iRidium Assistant service (iRidium
          server, i3pro, i3lite, i3knx, bus77home, bus77lite) do not receive your details or
          permission to access your data.
        </p>
        <p>
          IRidium project owners receive anonymous aggregated information what
          APIs and endpoints are used in
          <a href="https://developers.google.com/nest/device-access/api">
            Smart Device Management API </a
          >, as well as a special iRidium token of the iRidium managed object
          Assistant that links the received tokens through the Google client
          OAuth
        </p>
        <p>
          iRidium Assistant sends users to the address
          <a href="https://www.googleapis.com/oauth2/v4/token">
            https://www.googleapis.com/oauth2/v4/token
          </a>
          for authorization in Google and does not receive direct access and
          does not collect user data used by Google Auth.
        </p>

        <h2>Using user data</h2>
        <p>
          iRidium Assistant receives data for use in an iRidium project only
          after you provide a token that requires that you are authenticated as
          a specific Google user and logged in to integrate with the smart home
          control system.
        </p>
        <p></p>
        <p>
          iRidium Assistant can help you get a token by guiding you through
          OAuth mechanism in the browser. There you must agree to work iRidium
          Assistant applications on your behalf. OAuth consent screen will
          describe the scope of authorization, for example, it will indicate the
          target API and whether you allow read-only or read-write access.
        </p>

        <h2>Scopes</h2>
        <p>
          <code> userinfo.email </code> scope (view your email address)
          <code> userinfo.profile </code> scope (see your personal info.
          including any personal info you've made publicly available), and
          <code> openid </code> scope (authenticate using OpenID Connect) are
          required to be used by Google Auth.
        </p>
        <p>
          iRidium Assistant allows you to control Google Nest devices, so the
          default scopes also include
          <code> .../auth/sdm_fleet.service </code> (See and/or control Google
          Nest linked devices and services) and
          <code> .../auth/nest </code> (View and modify data shared by Nest
          devices).
        </p>
        <h2>User data exchange</h2>
        <p>
          iRidium Assistant interacts only with Google API. No user data is
          shared with the owners of the iRidium, GCP project Project or any
          other party.
        </p>

        <h2>Storing user data</h2>
        <p>
          iRidium Assistant stores only tokens about successful authorization
          via Google OAuth for later use by you in calls to [Smart Device
          Management API]. Having previously authorized in the system iRidium
          Assistant, on the page
          <a href="https://cws.iridi.com/services/oauth/i3pro/nest">
            https://cws.iridi.com/services/oauth/i3pro/nest
          </a>
          you can get iRidium token and Google Nest device structure for use
          when creating an i3pro project.
        </p>
        <p>
          iRidium token and structure of Google Nest devices are stored in the
          iRidium cloud projects, as well as on the user's local device(iRidium
          server), if the project was loaded and launched on iRidium server.
        </p>
        <h2>Use in other packages or applications</h2>
        <p>
          Do not use information about the structure of devices or iRidium
          tokens an object from iRidium Assistant in an external service or
          tool. According to
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            >Google User Data Policy</a
          >
          your application must represent itself exactly when authenticated in
          Google API services.
        </p>
        <p>
          If you use iRidium Assistant inside another service or an application
          that executes its own logic - as opposed to code in iRidium Assistant
          or by a user - you must clearly inform about this to the end user.
        </p>
        <p></p>

        <h2>Privacy Policy Changes</h2>
        <p>
          iRidium Assistant may modify or update this Privacy Policy from time
          to time, so please review it periodically. We may provide you
          additional forms of notice of modifications or updates as appropriate
          under the circumstances. Your continued use of iRidium Assistant after
          any modification to this Privacy Policy will constitute your
          acceptance of such modification.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  // data() {
  //   return {
  //   }
  // },
  // mounted(){
  //   this.$i18n.locale
  // }
}
</script>

<style>
.code,
code {
  background: rgba(135, 131, 120, 0.15);
  border-radius: 3px;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 85%;
  tab-size: 2;
}

code {
  color: #eb5757;
}

.code {
  padding: 1.5em 1em;
}

.code-wrap {
  white-space: pre-wrap;
  word-break: break-all;
}

.code > code {
  background: none;
  padding: 0;
  font-size: 100%;
  color: inherit;
}

blockquote {
  font-size: 1.25em;
  margin: 1em 0;
  padding-left: 1em;
  border-left: 3px solid rgb(55, 53, 47);
}
</style>
